import { Component, Input } from "@angular/core";
import { Sizes } from "../types/loader.types";

@Component({
  selector: "ds-loader",
  templateUrl: "./ds-loader.component.html",
  styleUrls: ["./ds-loader.component.scss"],
})
export class DsLoaderComponent {
  @Input() size: Sizes;
  @Input() customSize = "100%";

  constructor() {}
}
